export const tools = {
  energySaving: 'Energie Sparen',
  financeCockpit: 'Meine Finanzen',
  documents: 'Meine Unterlagen',
  taxSaving: 'Steuern sparen',
  counselor: 'Ratgeber',
  toDoOverview: 'To-do Übersicht',
  invoice: 'Meine Rechnungen',
  emptyText1: 'Sie haben derzeit noch keine To-dos',
  emptyText2: 'Wenn Sie To-dos erstellen, werden sie hier dargestellt.',
  emptyText3: 'Alle To-dos auf einen Blick!',
  emptyText4: 'Sie können To-dos direkt hier erstellen.',
  emptyText5: 'Die To-dos, die Sie in Ihrem Projekt erstellen, werden Sie auch hier sehen.',
  buttonText: 'To-do erstellen',
  insulationCalculator: 'Minergie Dämmrechner',
}
